'use client';
// We want to make a context that takes in the name of the active tab, and a list of children. We only want to render the children that have the
// 'title' prop equal to the activeTab
import { createContext } from 'react';
import { TabType } from './index';

export interface TabContextInterface {
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
}

const defaultProviderValue: TabContextInterface = {
  activeTab: { title: '' },
  setActiveTab: () => console.warn('setActiveTab not implemented'),
};

export const TabContext = createContext<TabContextInterface>(defaultProviderValue);

export interface TabContextProviderProps {
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
  children: React.ReactNode;
  className?: string;
}

export const TabContextProvider = ({ activeTab, children, setActiveTab }: TabContextProviderProps) => {
  return <TabContext.Provider value={{ activeTab, setActiveTab }}>{children}</TabContext.Provider>;
};
